import type { FeatureStyleNode } from '../feature-style.model';

// =============================================================================
// PARAMS - Feature configuration from widget config
// =============================================================================

/** Intersection feature parameters */
export interface IntersectionParams {
  /** References to two parent function elements */
  of: [string, string];
}

// =============================================================================
// DEFAULTS
// =============================================================================

/** No additional defaults beyond `of` which must be provided */
export const INTERSECTION_DEFAULT_PARAMS: Omit<IntersectionParams, 'of'> = {};

/**
 * Default theme for intersection feature.
 * Green colored points for intersection points.
 */
export const INTERSECTION_DEFAULTS: FeatureStyleNode = {
  point: { color: 'green', fixed: true },
};
